import {createInstance} from "i18next"
import {initReactI18next} from "react-i18next"
import HttpBackend from "i18next-http-backend"
import LanguageDetector from "i18next-browser-languagedetector"

import {VALID_LOCALES, ValidLocale} from "./Locales"
import {formatCurrency} from "./currencyFormatter"

const i18n = createInstance()
void i18n
	.use(LanguageDetector)
	.use(HttpBackend)
	.use(initReactI18next)
	.init(
		{
			fallbackLng: "en-AU",
			load: "currentOnly",
			supportedLngs: VALID_LOCALES,
			interpolation: {
				escapeValue: false,
				format: (value, format, lng, options) => {
					if (format === "currency") {
						return formatCurrency(
							value,
							options?.formatParams[options.interpolationkey]?.currency,
							lng as ValidLocale,
						)
					}
					return value
				},
			},
			backend: {
				loadPath: "/locales/{{lng}}.json",
			},
			saveMissing: true,
			missingKeyHandler(lngs, ns, key, fallbackValue, updateMissing, options) {
				console.error("missing i18n key", lngs, ns, key, fallbackValue, updateMissing, options)
				return fallbackValue
			},
		},
		(err) => {
			if (err) {
				console.error(err)
			}
		},
	)

export default i18n
